import { Icons } from '@cockpitai/components/atoms'
import { Typography } from '@cockpitai/components/atoms/Typography'
import { useSideBar } from '@cockpitai/components/organisms/Sidebar/SideBarContext'
import { routesPath } from '@cockpitai/constants/routesPath'
import { isMobile } from '@cockpitai/utils/device'
import { NavLink, useLocation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

type HomeButtonProps = {
  resetChat: () => void
  sidebarIsOpen: boolean
}

export function HomeButton({ resetChat, sidebarIsOpen }: HomeButtonProps) {
  const { pathname, search } = useLocation()

  const { setSidebarIsOpen } = useSideBar()

  const handleHomeClick = () => {
    setSidebarIsOpen(false)

    resetChat()
  }

  return (
    <li
      className="button-home"
      style={{ width: isMobile() || sidebarIsOpen ? '100%' : '35px' }}>
      <NavLink to={routesPath.dashboard.home}>
        <button
          onClick={handleHomeClick}
          className={twMerge(
            routesPath.dashboard.home === pathname &&
              search === '' &&
              'item-active',
          )}>
          <Icons.NewHome width={20} height={20} className="text-white" />
          <Typography className="text-white" weight="light">
            Home
          </Typography>
        </button>
      </NavLink>
    </li>
  )
}
